import { render, staticRenderFns } from "./SchemaNestedBreadcrumb.vue?vue&type=template&id=0ba36b22&"
import script from "./SchemaNestedBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./SchemaNestedBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports